import { Component, Input, OnInit } from '@angular/core';
import { KbnStatus, LIST_PERIOD_CONSTANT, PERIOD_CONSTANT } from '@core/constants';
import { Utils } from '@core/helper';
import { CommonHelper } from '@core/services/common';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'caremoni-meal-snack',
  templateUrl: './meal-snack.component.html',
  styleUrl: './meal-snack.component.scss'
})
export class MealSnackComponent implements OnInit {
  @Input() data: any = null;
  @Input() config: any = {};

  mealValue: string = '';
  snackValue: string = '';
  mealAttention: boolean = false;
  snackAttention: boolean = false;

  ngOnInit(): void {
    this.processMeal(this.data?.meal);
    this.processSnack(this.data?.snack);
  }

  processMeal(mealData: any): void {
    if (!mealData) return;
    if (Array.isArray(mealData)) {
      let arrayData: any[] = CommonHelper.getArrayData(cloneDeep(mealData)) || [];
      if (arrayData.length === 0) return;
      const currentMealData = this.getCurrentPeriodData(arrayData);
      if (currentMealData.length === 0) return;
      const currentPeriod = CommonHelper.getCurrentPeriod();
      if (!currentPeriod) return;
      arrayData = CommonHelper.filterLatestByPeriod(arrayData);
      const startHour = parseInt(currentPeriod.START.split(':')[0], 10);
      const endHour = parseInt(currentPeriod.END.split(':')[0], 10);
      const mealItem = arrayData?.find((item: any) => {
        const hour = new Date(item.date).getHours();
        return hour >= startHour && hour <= endHour;
      });
      if (mealItem?.isfeeding === true) {
        this.mealValue = '〇';
      } else {
        this.mealValue = this.formatMealValue(mealItem?.main, mealItem?.sub);
      }
      this.mealAttention = mealItem?.attention_flg || false;
    } else {
      if (mealData?.isfeeding === true) {
        this.mealValue = '〇';
      } else {
        this.mealValue = this.formatMealValue(mealData?.main, mealData?.sub);
      }
      this.mealAttention = mealData?.attention_flg || mealData?.feeding_attention_flg || false;
    }
  }

  processSnack(snackData: any): void {
    if (!snackData) return;
    if (snackData?.status_kbn == KbnStatus.STATUS_CARRY_OUT) {
      this.snackValue = '〇';
    }
    this.snackAttention = snackData?.attention_flg || false;
  }

  formatMealValue(main: any, sub: any): string {
    if (Utils.isNullOrEmpty(main) && Utils.isNullOrEmpty(sub)) return '';
    main = Utils.isValidNumber(main) ? main : '';
    sub = Utils.isValidNumber(sub) ? sub : '';
    return `${main}/${sub}`;
  }

  getCurrentPeriodData(dataArray: any[]): any[] {
    if (!Array.isArray(dataArray) || dataArray.length === 0) return [];
    const currentMealPeriod = CommonHelper.getCurrentPeriod();
    if (!currentMealPeriod) return [];
    return dataArray.filter((item: any) => {
      const itemHour = new Date(item.date).getHours();
      const start = parseInt(PERIOD_CONSTANT.MORNING.START?.split(':')[0], 10);
      const end = parseInt(currentMealPeriod.END.split(':')[0], 10);
      return itemHour >= start && itemHour <= end;
    });
  }
}
